import { gql } from '@apollo/client';

export const AUTHENTICATE_DEVICE_TIME = gql`
  query AuthenticateDeviceTime($input: AuthenticateDeviceTimeInput!) {
    authenticateDeviceTime(input: $input) {
      valid
    }
  }
`;
